module.exports = __webpack_public_path__ + "static/logo-sima-517b3a4592787d164fcdd4d70006ae67.png";